import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-[#0a0a0a]" data-id="element-567">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl py-20" data-id="element-568">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-569">
          <h1 className="text-3xl md:text-4xl font-medium text-white mb-4 tracking-tight" data-id="element-570">
            Política de Privacidad
          </h1>
          <p className="text-gray-400 text-sm mb-12" data-id="element-571">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            month: 'long',
            year: 'numeric'
          })}
          </p>

          <div className="space-y-10 text-gray-300 text-[15px] leading-relaxed" data-id="element-572">
            <section data-id="element-573">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-574">
                1. Responsable del tratamiento
              </h2>
              <p className="mb-4" data-id="element-575">
                Growthly LLC es el responsable del tratamiento de los datos
                personales del Usuario y le informa que estos datos serán
                tratados de conformidad con lo dispuesto en el Reglamento (UE)
                2016/679 de 27 de abril de 2016 (GDPR) y la Ley Orgánica 3/2018
                de 5 de diciembre (LOPDGDD).
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-576">
                <li data-id="element-577">
                  <strong data-id="element-578">Identidad:</strong> Growthly LLC
                </li>
                <li data-id="element-579">
                  <strong data-id="element-580">Teléfono:</strong> +34 631 01 25 92
                </li>
                <li data-id="element-581">
                  <strong data-id="element-582">Correo electrónico:</strong> hola@growthly.com{' '}
                  {/* Placeholder email */}
                </li>
              </ul>
            </section>

            <section data-id="element-583">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-584">
                2. Datos que recogemos
              </h2>
              <p className="mb-4" data-id="element-585">
                Recopilamos los datos estrictamente necesarios para el correcto
                desarrollo de nuestra actividad y la prestación de nuestros
                servicios. Estos datos incluyen:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-586">
                <li data-id="element-587">Datos identificativos: nombre y apellidos.</li>
                <li data-id="element-588">
                  Datos de contacto: dirección de correo electrónico y número de
                  teléfono.
                </li>
                <li data-id="element-589">
                  Datos de navegación: dirección IP, comportamiento en la web
                  (mediante cookies).
                </li>
              </ul>
            </section>

            <section data-id="element-590">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-591">
                3. Finalidad del tratamiento
              </h2>
              <p className="mb-4" data-id="element-592">
                Los datos personales proporcionados serán utilizados para las
                siguientes finalidades:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-593">
                <li data-id="element-594">
                  Gestionar la contratación de nuestros servicios de diseño y
                  desarrollo web.
                </li>
                <li data-id="element-595">
                  Responder a consultas, solicitudes o peticiones realizadas a
                  través de los canales de contacto.
                </li>
                <li data-id="element-596">
                  Enviar comunicaciones comerciales sobre nuestros servicios
                  (solo si se ha dado el consentimiento expreso).
                </li>
                <li data-id="element-597">
                  Mejorar la experiencia de usuario en nuestra página web.
                </li>
              </ul>
            </section>

            <section data-id="element-598">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-599">
                4. Base legal
              </h2>
              <p data-id="element-600">
                La base legal para el tratamiento de sus datos es la ejecución
                de un contrato (en caso de contratación de servicios), el
                consentimiento del interesado (para el envío de comunicaciones
                comerciales y el uso de cookies no técnicas) y el interés
                legítimo (para responder a consultas y mejorar nuestra web).
              </p>
            </section>

            <section data-id="element-601">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-602">
                5. Conservación de los datos
              </h2>
              <p data-id="element-603">
                Los datos se conservarán durante el tiempo necesario para
                cumplir con la finalidad para la que se recabaron y para
                determinar las posibles responsabilidades que se pudieran
                derivar de dicha finalidad y del tratamiento de los datos,
                además de los periodos establecidos en la normativa de archivos
                y documentación.
              </p>
            </section>

            <section data-id="element-604">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-605">
                6. Derechos del usuario
              </h2>
              <p className="mb-4" data-id="element-606">Como usuario, tiene derecho a:</p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-607">
                <li data-id="element-608">Acceder a sus datos personales.</li>
                <li data-id="element-609">Solicitar la rectificación de los datos inexactos.</li>
                <li data-id="element-610">
                  Solicitar su supresión cuando, entre otros motivos, los datos
                  ya no sean necesarios para los fines que fueron recogidos.
                </li>
                <li data-id="element-611">Solicitar la limitación del tratamiento de sus datos.</li>
                <li data-id="element-612">Oponerse al tratamiento de sus datos.</li>
                <li data-id="element-613">Solicitar la portabilidad de sus datos.</li>
              </ul>
              <p className="mt-4" data-id="element-614">
                Puede ejercer estos derechos enviando un correo electrónico a
                hola@growthly.com.
              </p>
            </section>

            <section data-id="element-615">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-616">
                7. Política de Cookies
              </h2>
              <p data-id="element-617">
                Esta página web utiliza cookies técnicas necesarias para su
                funcionamiento. También podemos utilizar cookies analíticas para
                entender cómo los usuarios interactúan con el sitio web. Puede
                configurar su navegador para rechazar todas las cookies o para
                que le avise cuando se envíe una cookie.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>;
}